import { IEntityChildren } from "./EntityChildren";

export interface IEntityListState<T> {
    SelectedEntity: number | null;
    SelectedEntityChildren: IEntityChildren[];
    ShowForm: boolean;
    ShowViewForm: boolean;
    Entities: { Timestamp: number | null, Items: T[] };
    HideDeleteDialog: boolean;
    HideDeleteDisallowed: boolean;
    EnableEdit?: boolean;
    EnableView?: boolean;
    EnableDelete?: boolean;
    EnableAddChild?: boolean;
    ListFilterText?: string | null;
    LoadingListData: boolean;
    LoadingDeleteCheck: boolean;
    ShowChildForm: boolean;
    ShowClosedEntities: boolean;
    EntityDescription1ForList: string;
    EntityDescription1ForForm: string;
    EntityDescription1DirectorateID?: number;
}

export class EntityListState<T> implements IEntityListState<T> {
    public SelectedEntity = null;
    public SelectedEntityChildren = [];
    public ShowForm = false;
    public ShowViewForm = false;
    public Entities = { Timestamp: null, Items: [] };
    public HideDeleteDialog = true;
    public HideDeleteDisallowed = true;
    public EnableEdit = false;
    public EnableView = false;
    public EnableDelete = false;
    public EnableAddChild = false;
    public ListFilterText = null;
    public LoadingListData = false;
    public LoadingDeleteCheck = false;
    public ShowChildForm = false;
    public ShowClosedEntities = false;
    public EntityDescription1ForList = '';
    public EntityDescription1ForForm = '';
    public EntityDescription1DirectorateID = null;
}
